import { configureStore } from "@reduxjs/toolkit";
import webSocketMiddleware from "./webSocketMiddleware";
import analyticsReducer from "./analyticsSlice";
import navigationReducer from "./navigationSlice";
import websocketReducer from "./websocketSlice"; 
import authReducer from "./authSlice"; 
import footerReducer from './footerSlice';  
import articleReducer from "./articleSlice";


const store = configureStore({
  reducer: {
    analytics: analyticsReducer,
    navigation: navigationReducer,
    websocket: websocketReducer,
    auth: authReducer, 
    article: articleReducer,
    footer: footerReducer,   
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(webSocketMiddleware), 
});

export default store;
